import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../components/Card';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import { MapPin } from 'lucide-react';
import { procedures } from '../data/procedures';
export function Procedures() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-1370">
      <Helmet data-id="element-1371">
        <title data-id="element-1372">Medical Procedures | Affordable Medical Tourism</title>
        <meta name="description" content="Explore our comprehensive range of medical, dental, and cosmetic procedures available through our network of internationally accredited hospitals." data-id="element-1373" />
        <link rel="canonical" href="https://affordablemedicaltourism.com/procedures" data-id="element-1374" />
      </Helmet>

      <AppHeader data-id="element-1375" />

      <main className="flex-1 py-20 px-6 md:px-12 max-w-7xl mx-auto w-full" data-id="element-1376">
        <div className="text-center mb-16" data-id="element-1377">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-1378">
            Medical Procedures
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1379">
            We facilitate access to a wide spectrum of high-acuity medical,
            dental, and cosmetic interventions. Our network comprises
            exclusively vetted, internationally accredited facilities equipped
            with state-of-the-art technology and staffed by globally trained
            specialists.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1380">
          {procedures.map(proc => {
          const Icon = proc.icon;
          return <Card key={proc.slug} className="flex flex-col h-full hover:shadow-lg transition-shadow" data-id="element-1381">
                <CardHeader data-id="element-1382">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 text-primary" data-id="element-1383">
                    <Icon className="w-6 h-6" data-id="element-1384" />
                  </div>
                  <CardTitle className="text-2xl" data-id="element-1385">{proc.name}</CardTitle>
                  <CardDescription className="text-base mt-2" data-id="element-1386">
                    {proc.shortBlurb}
                  </CardDescription>
                </CardHeader>
                <CardContent className="flex-1" data-id="element-1387">
                  <div className="space-y-5" data-id="element-1388">
                    <div data-id="element-1389">
                      <div className="text-sm text-slate-500 mb-1 uppercase tracking-wider font-semibold" data-id="element-1390">
                        Illustrative Pricing
                      </div>
                      <span className="text-3xl font-bold text-slate-900" data-id="element-1391">
                        from {proc.illustrativePriceFrom}
                      </span>
                    </div>
                    <Badge variant="secondary" className="bg-green-100 text-green-800 hover:bg-green-100 text-sm py-1" data-id="element-1392">
                      Illustrative Savings: up to {proc.illustrativeSavingsPct}
                    </Badge>
                    <div className="pt-4 border-t border-slate-100" data-id="element-1393">
                      <div className="text-sm text-slate-500 mb-2" data-id="element-1394">
                        Top Destinations
                      </div>
                      <div className="flex flex-wrap gap-2" data-id="element-1395">
                        {proc.destinations.map(dest => <Badge key={dest} variant="outline" className="text-slate-600 bg-slate-50" data-id="element-1396">
                            <MapPin className="w-3 h-3 mr-1" data-id="element-1397" /> {dest}
                          </Badge>)}
                      </div>
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="flex gap-3 border-t border-slate-100 pt-6" data-id="element-1398">
                  <Button variant="outline" className="flex-1" asChild data-id="element-1399">
                    <Link to={`/procedures/${proc.slug}`} data-id="element-1400">Learn more</Link>
                  </Button>
                  <Button className="flex-1" onClick={() => navigate('/contact')} data-id="element-1401">
                    Get a quote
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </main>

      <AppFooter data-id="element-1402" />
    </div>;
}